import type {PartValueModifier} from 'schemaDefinition/types';
import {languagesModifier} from 'schemas/valueModifiers/languagesModifier';

export const interceptExpressionSetFieldValue: PartValueModifier =
  parameters => {
    const {value, part} = parameters;

    if (part) {
      if (part.name === 'languages') {
        return languagesModifier(parameters);
      }
    }

    return {value};
  };
